import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { UI } from "../UI.js";
/**
 * Returns the computed style for a day based on its modifiers.
 *
 * This function merges the base styles for the day with any styles associated
 * with active modifiers.
 *
 * @param dayModifiers The modifiers applied to the day.
 * @param styles The base styles for the calendar elements.
 * @param modifiersStyles The styles associated with specific modifiers.
 * @returns The computed style for the day.
 */
export function getStyleForModifiers(dayModifiers) {
  let styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let modifiersStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let style = _objectSpread({}, styles === null || styles === void 0 ? void 0 : styles[UI.Day]);
  Object.entries(dayModifiers).filter(_ref => {
    let [, active] = _ref;
    return active === true;
  }).forEach(_ref2 => {
    let [modifier] = _ref2;
    style = _objectSpread(_objectSpread({}, style), modifiersStyles === null || modifiersStyles === void 0 ? void 0 : modifiersStyles[modifier]);
  });
  return style;
}